import * as React from 'react';
import {Redirect} from 'react-router-dom';
import Navbar from '../../components/CustomNav/CustomNav.Component';
import { currentBaseUrl, currentUser, isUserLoggedIn } from 'src/common/services';
import styled from 'styled-components';
import './lessonAssessmentResult.css';
import { CSSTransition } from 'react-transition-group'
// icons
import 'font-awesome/css/font-awesome.min.css';

const FailedSVG = styled.svg`
    // animation and styling rules specific to this svg go here
`

const PassedSVG = styled.svg`
    // animation and styling specific to this
`

const ExcellentSVG = styled.svg`
    // animation and styling
`

export default class LessonAssessmentResult extends React.Component {
    public state = {
        baseUrl: currentBaseUrl(),
        lessonScore: 9, // pass or fail for conditional render- can change to whatever type endpoint provides
        maxScore: 10, // maximum score attainable from a lesson assessment, replace with endpoint values
        destination: '',
        username: currentUser(),
        toLogin: false,
        toProfile: false,
        navigate: false
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.onProfile = this.onProfile.bind(this);
        this.toDashboard = this.toDashboard.bind(this);
        this.toReviewLesson = this.toReviewLesson.bind(this);
        this.displayPageContent = this.displayPageContent.bind(this);
        this.openWidget = this.openWidget.bind(this);
        this.toLessonTraining = this.toLessonTraining.bind(this);
        this.toNextLesson = this.toNextLesson.bind(this);
    }

    public componentDidMount() {
        if(!isUserLoggedIn()) {
            this.setState({toLogin: true})
        }else {
            console.log(currentUser() + " is logged in");
            
        }
    }

    public onLogout() {
        this.setState({toLogin: true});
    }

    public onProfile() {
        this.setState({navigate: true, destination: currentBaseUrl() + 'profile'});
    }

    public toDashboard() {
        // route back to dash
        this.setState({navigate: true, destination: currentBaseUrl() + "home"})
    }

    public toReviewLesson() {
        // route back to lesson preview
    }

    public openWidget() {
        // open see how to improve video (probably a modal)
    }

    public toLessonTraining() {
        // route to back to lesson training
        this.setState({navigate: true, destination: currentBaseUrl() + "lessonpreview"});
    }

    public toNextLesson() {
        // route to next lesson
    }
    public displayPageContent() {
        if(this.state.lessonScore <= 5) {
            // failed assessment
            return(
                <div className="lesson-result-container">
                    <h1 className="result-title">Oh no!</h1>
                    
                    <FailedSVG width="260" height="260" xmlns="http://www.w3.org/2000/svg">
                       
                        <linearGradient x1="17.306%" y1="79.998%" x2="86.922%" y2="21.537%" id="a">
                            <stop stop-color="#283583" offset="0%"/>
                            <stop stop-color="#F03" offset="100%"/>
                        </linearGradient>
                        
                        <path d="M130 260C58.203 260 0 201.797 0 130S58.203 0 130 0s130 58.203 130 130-58.203 130-130 130zm0-10c66.274 0 120-53.726 120-120S196.274 10 130 10 10 63.726 10 130s53.726 120 120 120zM62 78h10c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15h10c0 13.807-11.193 25-25 25S62 91.807 62 78zm86 0h10c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15h10c0 13.807-11.193 25-25 25s-25-11.193-25-25zm43.224 114.856l-9.034 4.288c-9.535-20.086-29.799-33.16-52.427-33.16-22.448 0-42.578 12.865-52.21 32.705l-8.996-4.367c11.29-23.254 34.892-38.338 61.206-38.338 26.526 0 50.285 15.33 61.461 38.872z" fill="url(#a)" fill-rule="nonzero"/>

                    </FailedSVG>                   
                    <p>We are very sorry, but you didn't pass the lesson. <br/>
                        But not to worry, you can review the lesson and <span onClick={this.openWidget}>see how to improve</span>
                    </p>
                    <div className="result-navigation">
                    <button className="result-to-dash blue-button" onClick={this.toDashboard}>Back to Dashboard</button>
                    <button className="result-to-review green-button" onClick={this.toReviewLesson}>Review Lesson</button>
                    </div>                    
                </div>
            );
        }
        else if(this.state.lessonScore >= 5 && this.state.lessonScore <=8) {
            // passed
            return(
                <div className="lesson-result-container">
                    <h1 className="result-title">Well Done!</h1>
                    
                    <PassedSVG width="250" height="229" xmlns="http://www.w3.org/2000/svg">
                        <linearGradient x1="86.922%" y1="26.118%" x2="17.306%" y2="75.17%" id="a">
                            <stop stop-color="#3EE9F7" offset="0%"/>
                            <stop stop-color="#ACFF24" offset="100%"/>
                        </linearGradient>
                     
                        <path d="M86.493 202.8c0 14.395-11.672 26.068-26.067 26.068H26.067C11.672 228.868 0 217.195 0 202.8v-83.247c0-14.395 11.672-26.069 26.067-26.069h34.359c14.395 0 26.067 11.674 26.067 26.07v83.246zm-13.16-85.448c0-6.428-5.251-11.64-11.727-11.64H25.061c-6.476 0-11.728 5.212-11.728 11.64v87.884c0 6.428 5.252 11.64 11.728 11.64h36.545c6.476 0 11.727-5.212 11.727-11.64v-87.884zm-24.444 78.61a6.581 6.581 0 0 1-6.58 6.582h-1.88a6.581 6.581 0 0 1-6.582-6.582v-1.88a6.581 6.581 0 0 1 6.581-6.581h1.88a6.581 6.581 0 0 1 6.581 6.58v1.881zM143.181 229c-18.715 0-38.819-2.377-45.636-30.744-.136-.571.23-1.165.23-1.756v-95.063c0-1.049-.215-2.09.214-3.05l1.27-3.366c2.099-6.494 8.21-16.392 18.077-31.721 6.746-10.485 13.673-21.33 15.827-26.784 3.667-9.277 3.652-21.785 3.347-25.817a7.515 7.515 0 0 1 3.61-7.014c.628-.38 6.336-3.685 13.718-3.685 4.704 0 9.044 1.305 12.906 3.87 10.457 6.953 22.171 17.818 19.866 40.3-.718 7.088-3.689 13.737-6.558 20.172-1.884 4.227-3.663 8.22-4.66 11.993-.202.767-.225 2.85-.236 4.595 8.201.707 16.455 1.331 23.882 1.331 4.682 0 8.491-.037 11.567-.071 3.982-.041 6.746-.064 8.687.008 1.417.03 2.748.075 3.974.236 8.153 1.087 15.4 5.288 20.397 11.824 4.997 6.536 7.148 14.63 6.062 22.786a30.807 30.807 0 0 1-11.436 20.086 27.3 27.3 0 0 1 3.069 16.645c-.888 6.679-4.107 12.636-9.138 17.002 0 .101.007.2.015.282 1.688 3.937 2.279 8.277 1.707 12.59-.823 6.18-4.087 11.81-8.95 15.645 1.294 3.16 1.723 6.683 1.23 10.346-1 7.469-6.302 13.772-13.605 16.257-4.419 2.23-9.999 2.697-17.437 2.697-2.508 0-5.306-.053-8.412-.11-3.787-.07-8.051-.15-12.838-.15-5.968 0-11.578.185-17.005.361-4.87.158-9.453.305-13.744.305zm-32.333-30.222c3.9 16.424 12.66 19.105 31.941 19.105 4.294 0 8.65-.148 13.518-.308 5.76-.188 11.594-.383 18.037-.383 5.074 0 9.532.082 13.545.16 3.12.058 5.897.11 8.408.11 2.25 0 9.091 0 11.139-1.181a7.781 7.781 0 0 1 1.657-.716c1.681-.496 3.62-2.037 3.912-4.25.12-.91.129-2.216-.519-3.283-1.677-2.749-2.125-6.459-1.216-9.942.807-3.085 2.597-5.54 5.05-6.916 2.59-1.458 4.298-3.964 4.684-6.869.23-1.732-.016-3.464-.71-5-1.774-3.921-2.219-13.367 3.264-17.413 2.855-2.091 4.669-5.153 5.133-8.636a12.781 12.781 0 0 0-1.974-8.687c-3.432-5.246-1.548-14.574 3.659-18.148a16.376 16.376 0 0 0 6.992-11.353 16.32 16.32 0 0 0-3.217-12.123 16.235 16.235 0 0 0-10.827-6.286 15.577 15.577 0 0 0-2.078-.114c-.094 0-.457 0-.554-.004-1.825-.074-4.536-.043-8.272 0-3.233.032-7.23.075-12.152.075-9.914 0-20.725-.962-31.181-1.889l-2.367-.21a7.8 7.8 0 0 1-5.351-2.835 7.826 7.826 0 0 1-1.716-5.817c.222-1.975.234-4.105.246-6.166.023-3.158.042-6.134.764-8.878 1.357-5.145 3.545-10.075 5.667-14.844 2.585-5.817 5.03-11.314 5.526-16.197 1.603-15.67-5.9-22.07-13.724-27.284-2.055-1.365-4.73-1.63-7.032-1.173-.05 6.709-.803 17.964-4.703 27.847-2.804 7.092-10.117 18.488-17.862 30.552-6.985 10.873-15.675 24.411-17.184 29.501-.093.317.238.63.102.935l-.605 2.408v96.212z" fill="url(#a)" fill-rule="nonzero"/>
                    </PassedSVG>                   
                    <p>You made a good effort! You got {this.state.lessonScore + "/" + this.state.maxScore} points <br/>
                        Now you just need to complete some training exercises to earn a new <br/> badge and unlock lesson 2
                    </p>
                    <div className="result-navigation">
                    <button className="result-to-dash blue-button" onClick={this.toDashboard}>Back to Dashboard</button>
                    <button className="result-to-review green-button" onClick={this.toLessonTraining}>Lesson Training</button>
                    </div>                    
                </div>
            );
        }
        else if(this.state.lessonScore >= 9 && this.state.lessonScore <=this.state.maxScore) {
            // impressive
            return(
                <div className="lesson-result-container">
                    <h1 className="result-title">Wow! Impressive!</h1>
                    
                    <ExcellentSVG width="162" height="253" xmlns="http://www.w3.org/2000/svg">  
                        <linearGradient x1="65.207%" y1="21.537%" x2="36.534%" y2="79.998%" id="a">
                            <stop stop-color="#3EE9F7" offset="0%"/>
                            <stop stop-color="#ACFF24" offset="100%"/>
                        </linearGradient>                    
                        <path d="M43.707 145.524c-1.05-.662-2.288-1.148-3.207-1.148h-.07l-3.865.18c-.338.015-.628.023-.922.023-5.27 0-10.188-2.068-13.79-5.82-3.605-3.762-5.46-8.785-5.213-14.072l.18-3.845c.074-1.57-1.583-4.427-2.998-5.153l-3.435-1.77c-4.854-2.496-8.342-6.758-9.74-11.943C-.748 96.79.134 91.36 3.09 86.771l2.092-3.25c.85-1.318.85-4.612-.002-5.933l-2.09-3.243C.135 69.755-.747 64.325.649 59.132c1.397-5.18 4.883-9.439 9.739-11.94l3.439-1.768c1.41-.726 3.068-3.584 2.995-5.15l-.18-3.85c-.248-5.285 1.608-10.308 5.217-14.07 3.596-3.75 8.514-5.819 13.785-5.819.306 0 .616.007.929.021l3.814.18.114.003c1.685 0 4.44-1.634 5.141-2.987l1.778-3.425C50.719 3.973 57.174 0 64.255 0c3.66 0 7.25 1.062 10.376 3.06l3.255 2.078c.552.352 1.706.64 3.015.64 1.306 0 2.46-.288 3.01-.638l3.258-2.081C90.298 1.061 93.888 0 97.546 0c7.082 0 13.536 3.973 16.838 10.329l1.776 3.423c.702 1.354 3.454 2.987 5.14 2.987l.113-.003 3.823-.18c.309-.014.615-.021.92-.021 5.273 0 10.197 2.07 13.788 5.818 3.607 3.76 5.46 8.782 5.217 14.072l-.18 3.848c-.073 1.569 1.583 4.426 2.993 5.151l3.44 1.77c4.856 2.5 8.344 6.761 9.74 11.945 1.39 5.188.51 10.615-2.443 15.206l-2.09 3.242c-.85 1.32-.849 4.616.002 5.935l.003.006 2.086 3.244c2.952 4.588 3.832 10.015 2.44 15.205-1.394 5.181-4.884 9.445-9.737 11.94l-3.445 1.775c-1.407.723-3.062 3.579-2.99 5.149l.182 3.853c.243 5.285-1.611 10.307-5.216 14.065-3.593 3.75-8.517 5.82-13.79 5.82-.293 0-.577-.008-.926-.023l-3.902-.182c.037.002.031.002-.029.002-1.008 0-2.397.584-3.502 1.343v96.246l-36.388-21.23-37.702 31.377V145.524zm10 12.35v72.906l26.69-22.213 27.4 15.986v-66.481a18.766 18.766 0 0 1-10.25 3.045c-3.656 0-7.247-1.065-10.376-3.063l-3.263-2.081c-.547-.35-1.698-.637-3.007-.637-1.312 0-2.463.287-3.015.64l-3.254 2.075c-3.129 2-6.72 3.066-10.377 3.066a18.77 18.77 0 0 1-10.548-3.244zm94.508-85.702l2.088-3.24c1.437-2.235 1.846-4.76 1.192-7.2-.655-2.435-2.284-4.425-4.656-5.647l-3.438-1.768c-4.89-2.514-8.665-9.028-8.41-14.512l.181-3.844c.118-2.569-.748-4.917-2.447-6.687-1.693-1.767-4.004-2.739-6.57-2.739-.152 0-.308.004-.457.01l-3.866.183-.1.003c-.193.006-.29.008-.433.008-5.379 0-11.574-3.677-14.015-8.381l-1.775-3.422c-1.59-3.062-4.636-4.936-7.963-4.936-1.74 0-3.465.51-4.996 1.487l-3.26 2.083c-2.286 1.457-5.292 2.209-8.39 2.209-3.1 0-6.105-.752-8.394-2.211l-3.26-2.082C67.72 10.51 65.996 10 64.257 10c-3.327 0-6.373 1.874-7.962 4.935l-1.776 3.423c-2.441 4.704-8.64 8.38-14.018 8.38-.142 0-.245-.002-.432-.007l-.101-.003-3.86-.182c-.153-.007-.31-.011-.464-.011-2.564 0-4.87.97-6.569 2.741-1.697 1.77-2.564 4.117-2.445 6.68l.18 3.85c.257 5.483-3.52 11.997-8.41 14.51l-3.436 1.768c-2.374 1.222-4.002 3.212-4.659 5.647-.656 2.44-.246 4.963 1.193 7.198l2.089 3.242c2.978 4.618 2.978 12.152.002 16.767l-2.09 3.247c-1.44 2.235-1.85 4.757-1.195 7.19.658 2.442 2.287 4.433 4.66 5.653l3.432 1.768c4.892 2.511 8.67 9.026 8.415 14.514l-.18 3.844c-.12 2.567.746 4.915 2.44 6.683 1.701 1.772 4.009 2.742 6.573 2.742.119 0 .267-.004.461-.013l3.83-.178c.12-.006.233-.01.35-.011l.216-.001c5.377 0 11.575 3.675 14.018 8.378l1.775 3.421c1.592 3.065 4.639 4.942 7.962 4.942 1.734 0 3.459-.512 4.996-1.494l3.253-2.075c2.286-1.462 5.292-2.212 8.397-2.212 3.102 0 6.108.75 8.389 2.209l3.26 2.079c1.536.981 3.263 1.493 4.996 1.493 3.324 0 6.37-1.877 7.962-4.94l1.777-3.425c2.441-4.701 8.637-8.376 14.014-8.376.24 0 .365.002.53.01l3.86.18c.204.01.349.013.467.013 2.565 0 4.876-.971 6.571-2.74 1.697-1.769 2.563-4.117 2.445-6.68l-.18-3.85c-.256-5.487 3.52-12.002 8.405-14.51l3.442-1.773c2.371-1.22 4-3.21 4.655-5.643.655-2.442.246-4.966-1.192-7.201l-2.086-3.244c-2.975-4.618-2.975-12.147-.001-16.766zm-22.613 8.385h4c0 26.78-21.81 48.48-48.7 48.48-26.896 0-48.704-21.7-48.704-48.48 0-26.78 21.808-48.48 48.703-48.48 26.891 0 48.7 21.7 48.7 48.48h-4zm0 0h-4c0-22.352-18.219-40.48-40.7-40.48-22.486 0-40.704 18.127-40.704 40.48 0 22.353 18.218 40.48 40.703 40.48 22.482 0 40.7-18.128 40.7-40.48h4zM80.899 90.98l-15.726 11.56 6.184-18.462-15.902-11.32 19.547.151L80.9 54.353l5.9 18.555 19.548-.15-15.905 11.319 6.184 18.462-15.727-11.56z" fill="url(#a)" fill-rule="nonzero"/>
                    </ExcellentSVG>    
                    <div className="result-social-media">
                        <i className="fa fa-facebook-square"/>
                        <i className="fa fa-twitter-square"/>
                        <i className="fa fa-instagram"/>
                    </div>               
                    <p>You made a good effort! You got {this.state.lessonScore + "/" + this.state.maxScore} points <br/>
                        Now you just need to complete some training exercises to earn a new <br/> badge and unlock lesson 2
                    </p>
                    <div className="result-navigation">
                        <button className="blue-button result-to-dash" onClick={this.toDashboard}>Back to Dashboard</button>
                        <button className="green-button result-to-review" onClick={this.toLessonTraining}>Lesson 1 Training</button>
                        <button className="red-button result-next-lesson" onClick={this.toNextLesson}>Lesson 2</button>

                    </div>                    
                </div>
            );
        }
        else {
            return(<p>Something went wrong, try again</p>);
        }
    }

    public render() {
        if(this.state.toLogin) {
            return <Redirect to="/login" />
        }

        if(this.state.navigate) {
            return <Redirect to={this.state.destination} />
        }
        return(
            <div>
                <Navbar logoutParent={this.onLogout} profileParent={this.onProfile}/>
                <CSSTransition
                    in={true}
                    appear={true}
                    classNames="fade"
                    timeout={800}
                >
                {this.displayPageContent()}
                </CSSTransition>
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/Feedback/lessonAssessmentResult.Component.tsx